import React from "react";
import Select from "react-select";
import { Button } from "../../../common/Button/Button";
import { useState } from "react";
import "../../../styles/lpmadmin.scss";
import { ChevronDown, User } from "react-feather";
import { useEffect } from "react";
import { X } from "react-feather";

export default function HandholderAssignment(props) {

	const [isOutboundCallOpen, setisOutboundCallOpen] = useState(false);
	const handleOutboundClick = () => 
	{
		setisOutboundCallOpen(!isOutboundCallOpen);
	};

	return (
		<>
			<div className="row" style={{marginTop:"5px"}}>
				<div className={props.assignFacilitators?("col-md-12"):("col-md-12")}>
					{props.assignFacilitators ? (
						<label>
							<b>Assign Facilitators</b>
						</label>
					) : (
						<label>
							<b>Assign Handholder</b>
						</label>
					)}
					<div className="row">
						{props.assignFacilitators?
						(
							<>
							<div className="col-md-12 inline-margin-assign">
								<Select
									options={
										props.assignFacilitators
											? props.facilitatorList
											: props.handholderList
									}
									onChange={props.onSelectHandholder}
									value={props.selectedHandholder}
									isClearable
								/>

								<div
									className={
										props.numberOfServices !== 0 &&
										props.selectedHandholder
											? ""
											: "disable"
									}
								>
									{props.deactivationModal === true ? (
										<></>
									) : (
										<Button onClick={props.onAssignHandholder}>
											Assign
										</Button>
									)}
								</div>
							</div>
							</>
						):
						(
							<>
							<div className="col-md-12 inline-margin-assign-hh">
								<Select
									options={
										props.assignFacilitators
											? props.facilitatorList
											: props.handholderList
									}
									onChange={props.onSelectHandholder}
									value={props.selectedHandholder}
									isClearable
								/>
								<div
									className={props.numberOfServices !== 0 &&	props.selectedHandholder? "": "disable"}
								>
									{props.deactivationModal === true ? (
										<></>
									) : (
										<Button onClick={props.onAssignHandholder}>
											Assign
										</Button>
									)}
								</div>
								<div
									className={
										props.numberOfServices !== 0 &&
										props.selectedServiceRequestsHasHandholder
											? ""
											: "disable"
									}
								>
									{props.deactivationModal === true ||
									props.assignFacilitators === true ? (
										<></>
									) : (
										<Button onClick={props.onUnAssignHandholder}>
											Un-assign
										</Button>
									)}
								</div>
								{props.deactivationModal === true ||
									props.assignFacilitators === true ? (
										<></>
									) : (
									<div>
										<Button onClick={handleOutboundClick}>
												Outbound Calling Report Actions
										</Button>
										{isOutboundCallOpen?
										(<div className="divFloat">
											<div className="row">
												<div className="col-md-12">
													<Button onClick={props.generateCallingReport}>
														Generate
													</Button>
													<input className="form-control-custom" type="file"onChange={props.onOutboundUpload}>
													</input>
													<Button onClick={props.uploadOutboundReport}>
														Upload
													</Button>
													<Button onClick={props.downloadOutboundUploadLogs}>
														Log
													</Button>	
													<button onhou className="outbound-close" onClick={handleOutboundClick} >
														<X/>
													</button>							
												</div>
												<div style={{clear:"both",margin:"5px"}}></div>
												<div className="col-md-12">
													Hint: First Upload Ameyo report {" "}
													<a
														target="_BLANK"
														href="https://drive.google.com/drive/u/1/folders/1Yb3jl342B2iZFa1OG0cFDaCKuW3Njw9Y"
													>
														here
													</a>
												</div>
											</div>
										</div>
										):("")}
									</div>
								)}
							</div>
							</>
						)}
					</div>
				</div>
			</div>
		</>
	);
}
